export default "__VITE_ASSET__DF4En41G__"